<span [ngClass]="ngClass">
  <ng-container [ngSwitch]="buttonType">
    <a
      *ngSwitchCase="'native-link'"
      class="link-underline-light"
      [ngClass]="ngAssign({ 'disabled': disabled }, ngClass)"
      (click)="onClick($event)"
    >
      <mat-icon *ngIf="iconKey" [ngClass]="iconNgClass">{{iconKey}}</mat-icon>
      {{buttonTitle || ''}}
      <ng-content></ng-content>
    </a>
    <button
      *ngSwitchCase="'mat-icon-button'"
      mat-icon-button
      [ngClass]="buttonNgClass"
      [disabled]="disabled"
      [color]="color"
      (click)="onClick($event)"
    >
      <mat-icon [ngClass]="iconNgClass">{{iconKey || 'adb'}}</mat-icon>
    </button>
    <button
      *ngSwitchDefault
      mat-raised-button
      [ngClass]="buttonNgClass"
      [disabled]="disabled"
      [color]="color"
      (click)="onClick($event)"
    >
      <mat-icon *ngIf="iconKey" [ngClass]="iconNgClass">{{iconKey}}</mat-icon>
      {{buttonTitle || ''}}
      <ng-content></ng-content>
    </button>
  </ng-container>
</span>
